import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createAutomation,
  getWhatssapQr,
  updateAutomation,
} from "../../../../../../actions/automate";
import AutomateCreateIn from "../AutomateCreateIn/AutomateCreateIn";
import { ReactComponent as GmailIcon } from "../../../../assets/gmailwithoutbg.svg";
import { ReactComponent as OutlookIcon } from "../../../../assets/outlook.svg";
import { ReactComponent as EmailIcon } from "../../../../assets/email.svg";
import { ReactComponent as DriveIcon } from "../../../../assets/driveCircle.svg";
import { ReactComponent as DropboxIcon } from "../../../../assets/dropbox-icon.svg";
import { ReactComponent as WhatsAppIcon } from "../../../../assets/whatsappIcon.svg";
import { ReactComponent as SharepointIcon } from "../../../../assets/sharePointCircle.svg";
import { ReactComponent as OneDriveIcon } from "../../../../assets/oneDriveCircle.svg";
import AddConnectionModal from "../AddConenctionModal/AddConnectionModal";
import styles from "./AutomatesComponentIn.module.css";
import { useTranslation } from "react-i18next";
import VariableModal from "../../../VariableModal/VariableModal";

const AutomatesComponentIn = ({
  type,
  automationData,
  formAutomateContainerRef,
  saveConfiguration,
  typeVariableModal,
  setTypeVariableModal,
  showVariableListModal,
  setShowVariableListModal,
  showVariableModalIn,
  setShowVariableModalIn,cardSelected,
  // setQuestion,
  selectedAgent,
  configuration,
  setConfiguration,
  toggleChatSettings,
  setToggleChatSettings
}) => {
  const [t] = useTranslation("AutomatesComponent");

  const [showCategory, setShowCategory] = useState(false);
  const [showFormtoGetQr, setShowFormtoGetQr] = useState(true);
  const [deviceName, setDeviceName] = useState("");
  const { user } = useSelector((state) => state.user);
  // const gloabalstate = useSelector((state) => state.automate);
  const dispatch = useDispatch();

  const [showQrWhatsApp, setShowQrWhatsApp] = useState(false);
  const [qr, setQr] = useState("");
  const whatsappQr = useSelector((state) => state.automate.whatsappQr);

// console.log("cardSelected", cardSelected);


  useEffect(() => {
    setQr(whatsappQr);
    return () => {
      setQr("");
    };
  }, [whatsappQr]);


  // const [gmailConfiguration, setGmailConfiguration] = useState({
  //   type: "Gmail",
  //   folderLocation: "/Inicio/",
  //   includeAllRemitents: true,
  //   subjectExactMatch: true,
  //   bodyExactMatch: true,
  //   attachmentExactMatch: true,
  //   selectedTypes: [],
  //   addedRemitents: [],
  //   subjectKeyWords: [],
  //   bodyKeyWords: [],
  //   emailConnectionData: [],
  //   selectedEmailConnection: "",
  //   fileName: "",
  //   tags: "",
  //   notificateAfterExport: false,
  //   notificateGmail: false,
  //   notificateWhatsApp: false,
  //   gmailTo: "",
  //   gmailSubject: "",
  //   gmailBody: "",
  //   whatsAppToNotificate: "",
  //   whatsAppMessage: "",
  //   totalAmount: {
  //     currency: "USD",
  //     min: 0,
  //     max: 0,
  //   },

  //   inputType: true,

  //   labels: null,
  //   filesExactMatch: false,
  //   phoneListNotificate: [],
  //   showContentSelectInfoToProcess: null,
  //   showContentImport: null,
  //   showContentExport: null,
  //   shotContentNotification: null,
  //   emailListColab: [],
  //   showContent: {
  //     info1: false,
  //     info2: false,
  //     info3: false,
  //     info4: false,
  //     info5: false,
  //     info6: false,
  //     info7: false,
  //     info8: false,
  //     info9: false,
  //   },
  //   actionFrequency: null,
  // });

  // const [outlookConfiguration, setOutlookConfiguration] = useState({
  //   type: "Outlook",
  //   folderLocation: "/Inicio/",
  //   includeAllRemitents: true,
  //   subjectExactMatch: true,
  //   bodyExactMatch: true,
  //   attachmentExactMatch: true,
  //   selectedTypes: [],
  //   addedRemitents: [],
  //   subjectKeyWords: [],
  //   bodyKeyWords: [],
  //   emailConnectionData: [],
  //   selectedEmailConnection: "",
  //   fileName: "",
  //   tags: "",
  //   notificateAfterExport: false,
  //   notificateGmail: false,
  //   notificateWhatsApp: false,
  //   gmailTo: "",
  //   gmailSubject: "",
  //   gmailBody: "",
  //   whatsAppToNotificate: "",
  //   whatsAppMessage: "",

  //   inputType: true,

  //   totalAmount: {
  //     currency: "USD",
  //     min: 0,
  //     max: 0,
  //   },
  //   labels: null,
  //   filesExactMatch: false,
  //   phoneListNotificate: [],
  //   showContentSelectInfoToProcess: null,
  //   showContentImport: null,
  //   showContentExport: null,
  //   shotContentNotification: null,
  //   emailListColab: [],
  //   showContent: {
  //     info1: false,
  //     info2: false,
  //     info3: false,
  //     info4: false,
  //     info5: false,
  //     info6: false,
  //     info7: false,
  //     info8: false,
  //     info9: false,
  //   },
  //   actionFrequency: null,
  // });

  // const [smtpConfiguration, setSmtpConfiguration] = useState({
  //   type: "SMTP",
  //   folderLocation: "/Inicio/",
  //   includeAllRemitents: true,
  //   subjectExactMatch: true,
  //   bodyExactMatch: true,
  //   attachmentExactMatch: true,
  //   selectedTypes: [],
  //   addedRemitents: [],
  //   subjectKeyWords: [],
  //   bodyKeyWords: [],
  //   emailConnectionData: [],
  //   selectedEmailConnection: "",
  //   fileName: "",
  //   tags: "",
  //   notificateAfterExport: false,
  //   notificateGmail: false,
  //   notificateWhatsApp: false,
  //   gmailTo: "",
  //   gmailSubject: "",
  //   gmailBody: "",
  //   whatsAppToNotificate: "",
  //   whatsAppMessage: "",

  //   inputType: true,

  //   totalAmount: {
  //     currency: "USD",
  //     min: 0,
  //     max: 0,
  //   },
  //   labels: null,
  //   filesExactMatch: false,
  //   phoneListNotificate: [],
  //   showContentSelectInfoToProcess: null,
  //   showContentImport: null,
  //   showContentExport: null,
  //   shotContentNotification: null,
  //   emailListColab: [],
  //   showContent: {
  //     info1: false,
  //     info2: false,
  //     info3: false,
  //     info4: false,
  //     info5: false,
  //     info6: false,
  //     info7: false,
  //     info8: false,
  //     info9: false,
  //   },
  //   actionFrequency: null,
  // });

  // const [whatsAppConfiguration, setWhatsAppConfiguration] = useState({
  //   type: "WhatsApp",
  //   phoneNumber: "",
  //   folderLocation: "/Inicio/",
  //   selectedWhatsAppConnection: "",
  //   whatsAppConnectionData: [],
  //   phoneNumbers: [],
  //   notificateAfterExport: false,
  //   notificateGmail: false,
  //   notificateWhatsApp: false,
  //   gmailTo: "",
  //   gmailSubject: "",
  //   gmailBody: "",
  //   whatsAppMessage: "",
  //   inputType: true,
  //   showContent: {
  //     info1: false,
  //     info2: false,
  //     info3: false,
  //     info4: false,
  //     info5: false,
  //     info6: false,
  //     info7: false,
  //     info8: false,
  //     info9: false,
  //   },
  //   actionFrequency: null,
  // });

  // const [googleDriveConfiguration, setGoogleDriveConfiguration] = useState({
  //   type: "Google Drive",
  //   folderLocation: "/Inicio/",
  //   selectedGoogleDriveConnection: "",
  //   googleDriveConnectionData: [],
  //   filesKeyWords: [],
  //   filesKeyWordsExactMatch: true,
  //   selectedFileTypes: [],
  //   allowAllFileTypes: true,
  //   changeFileName: false,
  //   fileName: "",
  //   notificateAfterExport: true,
  //   notificateGmail: false,
  //   notificateWhatsApp: false,
  //   gmailTo: "",
  //   gmailSubject: "",
  //   gmailBody: "",
  //   whatsAppToNotificate: "",
  //   whatsAppMessage: "",
  //   inputType: true,
  //   showContent: {
  //     info1: false,
  //     info2: false,
  //     info3: false,
  //     info4: false,
  //     info5: false,
  //     info6: false,
  //     info7: false,
  //     info8: false,
  //     info9: false,
  //   },
  //   actionFrequency: null,
  // });

  // const [dropBoxConfiguration, setDropBoxConfiguration] = useState({
  //   type: "Dropbox",
  //   folderLocation: "/Inicio/",
  //   selectedDropboxConnection: "",
  //   dropboxConnectionData: [],
  //   filesKeyWords: [],
  //   filesKeyWordsExactMatch: true,
  //   selectedFileTypes: [],
  //   allowAllFileTypes: true,
  //   changeFileName: false,
  //   fileName: "",
  //   notificateAfterExport: true,
  //   notificateGmail: false,
  //   notificateWhatsApp: false,
  //   gmailTo: "",
  //   gmailSubject: "",
  //   gmailBody: "",
  //   whatsAppToNotificate: "",
  //   whatsAppMessage: "",
  //   inputType: true,
  //   showContent: {
  //     info1: false,
  //     info2: false,
  //     info3: false,
  //     info4: false,
  //     info5: false,
  //     info6: false,
  //     info7: false,
  //     info8: false,
  //     info9: false,
  //   },
  //   actionFrequency: null,
  // });

  // const [oneDriveConfiguration, setOneDriveConfiguration] = useState({
  //   type: "One Drive",
  //   folderLocation: "/Inicio/",
  //   includeAllRemitents: true,
  //   subjectExactMatch: true,
  //   bodyExactMatch: true,
  //   attachmentExactMatch: true,
  //   selectedTypes: [],
  //   addedRemitents: [],
  //   subjectKeyWords: [],
  //   bodyKeyWords: [],
  //   emailConnectionData: [],
  //   selectedEmailConnection: "",
  //   fileName: "",
  //   tags: "",
  //   notificateAfterExport: false,
  //   notificateGmail: false,
  //   notificateWhatsApp: false,
  //   gmailTo: "",
  //   gmailSubject: "",
  //   gmailBody: "",
  //   whatsAppToNotificate: "",
  //   whatsAppMessage: "",
  //   totalAmount: {
  //     currency: "USD",
  //     min: 0,
  //     max: 0,
  //   },

  //   inputType: true,

  //   labels: null,
  //   filesExactMatch: false,
  //   phoneListNotificate: [],
  //   showContentSelectInfoToProcess: null,
  //   showContentImport: null,
  //   showContentExport: null,
  //   shotContentNotification: null,
  //   emailListColab: [],
  //   showContent: {
  //     info1: false,
  //     info2: false,
  //     info3: false,
  //     info4: false,
  //     info5: false,
  //     info6: false,
  //     info7: false,
  //     info8: false,
  //     info9: false,
  //   },
  //   actionFrequency: null,
  // });

  // const [sharepointConfiguration, setSharepointConfiguration] = useState({
  //   type: "Sharepoint",
  //   folderLocation: "/Inicio/",
  //   includeAllRemitents: true,
  //   subjectExactMatch: true,
  //   bodyExactMatch: true,
  //   attachmentExactMatch: true,
  //   selectedTypes: [],
  //   addedRemitents: [],
  //   subjectKeyWords: [],
  //   bodyKeyWords: [],
  //   emailConnectionData: [],
  //   selectedEmailConnection: "",
  //   fileName: "",
  //   tags: "",
  //   notificateAfterExport: false,
  //   notificateGmail: false,
  //   notificateWhatsApp: false,
  //   gmailTo: "",
  //   gmailSubject: "",
  //   gmailBody: "",
  //   whatsAppToNotificate: "",
  //   whatsAppMessage: "",
  //   totalAmount: {
  //     currency: "USD",
  //     min: 0,
  //     max: 0,
  //   },
  //   actionFrequency: null,
  //   inputType: true,
  //   labels: null,
  //   filesExactMatch: false,
  //   phoneListNotificate: [],
  //   showContentSelectInfoToProcess: null,
  //   showContentImport: null,
  //   showContentExport: null,
  //   shotContentNotification: null,
  //   emailListColab: [],
  //   showContent: {
  //     info1: false,
  //     info2: false,
  //     info3: false,
  //     info4: false,
  //     info5: false,
  //     info6: false,
  //     info7: false,
  //     info8: false,
  //     info9: false,
  //   },
  // });

  useEffect(() => {
    function clearObject(obj) {
      if (obj && typeof obj === "object" && !Array.isArray(obj)) {
        return Object.fromEntries(
          Object.entries(obj).map(([key, value]) => [key, clearObject(value)])
        );
      }
      return "";
    }

    setConfiguration((prev) => {
      const newConfigurationData = clearObject(prev);
      return newConfigurationData;
    });

    // setSharepointConfiguration((prev) => {
    //   const newConfigurationData = clearObject(prev);
    //   return newConfigurationData;
    // });
    // setDropBoxConfiguration((prev) => {
    //   const newConfigurationData = clearObject(prev);
    //   return newConfigurationData;
    // });
    // setOneDriveConfiguration((prev) => {
    //   const newConfigurationData = clearObject(prev);
    //   return newConfigurationData;
    // });
    // setGoogleDriveConfiguration((prev) => {
    //   const newConfigurationData = clearObject(prev);
    //   return newConfigurationData;
    // });
    // setGmailConfiguration((prev) => {
    //   const newConfigurationData = clearObject(prev);
    //   return newConfigurationData;
    // });
    // setOutlookConfiguration((prev) => {
    //   const newConfigurationData = clearObject(prev);
    //   return newConfigurationData;
    // });
    // setWhatsAppConfiguration((prev) => {
    //   const newConfigurationData = clearObject(prev);
    //   return newConfigurationData;
    // });

  }, [type]);

  useEffect(() => {
    if (automationData) {
      setConfiguration(automationData)
      // if (automationData.type === "WhatsApp") {
      //   setWhatsAppConfiguration(automationData);
      // } else if (automationData.type === "Gmail") {
      //   setGmailConfiguration(automationData);
      // } else if (automationData.type === "Outlook") {
      //   setOutlookConfiguration(automationData);
      // } else if (automationData.type === "Google Drive") {
      //   setGoogleDriveConfiguration(automationData);
      // } else if (automationData.type === "Dropbox") {
      //   setDropBoxConfiguration(automationData);
      // } else if (automationData.type === "One Drive") {
      //   setOneDriveConfiguration(automationData);
      // } else if (automationData.type === "Sharepoint") {
      //   setSharepointConfiguration(automationData);
      // }
    }
  }, [automationData]);

  useEffect(() => {
    if (saveConfiguration) {
      const handleAddAutomation = async () => {

        let selectedAutomationData;
        selectedAutomationData = {
          ...configuration,
          type: type,
        }
        // if (type === "Gmail") {
        //   selectedAutomationData = {
        //     ...gmailConfiguration,
        //     type: type,
        //   };
        // } else if (type === "Outlook") {
        //   selectedAutomationData = {
        //     ...outlookConfiguration,
        //     type: type,
        //   };
        // } else if (type === "WhatsApp") {
        //   selectedAutomationData = {
        //     ...whatsAppConfiguration,
        //     type: type,
        //   };
        // } else if (type === "Google Drive") {
        //   selectedAutomationData = {
        //     ...googleDriveConfiguration,
        //     type: type,
        //   };
        // } else if (type === "Dropbox") {
        //   selectedAutomationData = {
        //     ...dropBoxConfiguration,
        //     type: type,
        //   };
        // } else if (type === "One Drive") {
        //   selectedAutomationData = {
        //     ...oneDriveConfiguration,
        //     type: type,
        //   };
        // } else if (type === "Sharepoint") {
        //   selectedAutomationData = {
        //     ...sharepointConfiguration,
        //     type: type,
        //   };
        // }
        if (
          type === "Gmail" ||
          type === "Outlook" ||
          type === "WhatsApp" ||
          type === "Google Drive" ||
          type === "Dropbox" ||
          type === "One Drive" ||
          type === "Sharepoint"
        ) {
          if (user && selectedAutomationData?.id) {
            console.log('actualizando automatizacoin',selectedAutomationData)
            dispatch(
              updateAutomation({
                automationId: selectedAutomationData?._id,
                toUpdate: {...cardSelected,...selectedAutomationData},
                userId: user?.id,
              })
            );
          } else if (user) {
            console.log('creando automatizacion')
            dispatch(
              createAutomation({
                userId: user?.id,
                email: user?.email,
                automationData: {...cardSelected,...selectedAutomationData},
              })
            );
          }
        }
      };
      handleAddAutomation();
    }
  }, [saveConfiguration]);

  const handlePopUps = (fromWhat) => {

    if (fromWhat === "qr") {
      setShowQrWhatsApp((prev) => {
        if (!showFormtoGetQr) {
          setShowFormtoGetQr(true);
        }
        return !prev;
      });
    } else {
      setShowCategory((prev) => !prev);
    }
  };

  const generateQR = async (e) => {
    e.preventDefault();
    dispatch(getWhatssapQr({ userId: user.id, deviceName }));
    setDeviceName("");
    setShowFormtoGetQr(false);
  };

  const [showVariableModal, setShowVariableModal] = useState(false);

  const formRef = useRef(null);
  useEffect(() => {
    if (formRef.current && showFormtoGetQr) {
      formRef.current.focus();
    }
  }, [showFormtoGetQr, showQrWhatsApp]);

  return (
    <>
     <AutomateCreateIn
                type={type}
                configuration={configuration}
                setConfiguration={setConfiguration}
                setShowCategory={handlePopUps}
                formAutomateContainerRef={formAutomateContainerRef}
                iconType={<GmailIcon height={"25px"} width={"25px"} />}
                IconHeaderModAddConnection={GmailIcon}
                typeVariableModal={typeVariableModal}
                setTypeVariableModal={setTypeVariableModal}
                showVariableListModal={showVariableListModal}
                setShowVariableListModal={setShowVariableListModal}
                showVariableModal={showVariableModalIn}
                setShowVariableModal={setShowVariableModalIn}
                // setQuestion={setQuestion}
                selectedAgent={selectedAgent}
                toggleChatSettings={toggleChatSettings}
                setToggleChatSettings={setToggleChatSettings}
              />
      {/* {(() => {
        switch (type) {
          case "Gmail":
            return (
              <AutomateCreateIn
                type={type}
                configuration={gmailConfiguration}
                setConfiguration={setGmailConfiguration}
                setShowCategory={handlePopUps}
                formAutomateContainerRef={formAutomateContainerRef}
                iconType={<GmailIcon height={"25px"} width={"25px"} />}
                IconHeaderModAddConnection={GmailIcon}
                typeVariableModal={typeVariableModal}
                setTypeVariableModal={setTypeVariableModal}
                showVariableListModal={showVariableListModal}
                setShowVariableListModal={setShowVariableListModal}
                showVariableModal={showVariableModalIn}
                setShowVariableModal={setShowVariableModalIn}
                // setQuestion={setQuestion}
                selectedAgent={selectedAgent}
              />
            );
          case "Outlook":
            return (
              <AutomateCreateIn
                type={type}
                configuration={outlookConfiguration}
                setConfiguration={setOutlookConfiguration}
                setShowCategory={handlePopUps}
                formAutomateContainerRef={formAutomateContainerRef}
                iconType={<OutlookIcon height={"25px"} width={"25px"} />}
                IconHeaderModAddConnection={OutlookIcon}
                typeVariableModal={typeVariableModal}
                setTypeVariableModal={setTypeVariableModal}
                showVariableListModal={showVariableListModal}
                setShowVariableListModal={setShowVariableListModal}
                showVariableModal={showVariableModalIn}
                setShowVariableModal={setShowVariableModalIn}
                // setQuestion={setQuestion}
                selectedAgent={selectedAgent}
              />
            );
          case "SMTP":
            return (
              <AutomateCreateIn
                type={type}
                configuration={smtpConfiguration}
                setConfiguration={setSmtpConfiguration}
                setShowCategory={handlePopUps}
                formAutomateContainerRef={formAutomateContainerRef}
                iconType={<EmailIcon height={"25px"} width={"25px"} />}
                IconHeaderModAddConnection={EmailIcon}
                typeVariableModal={typeVariableModal}
                setTypeVariableModal={setTypeVariableModal}
                showVariableListModal={showVariableListModal}
                setShowVariableListModal={setShowVariableListModal}
                showVariableModal={showVariableModalIn}
                setShowVariableModal={setShowVariableModalIn}
                // setQuestion={setQuestion}
                selectedAgent={selectedAgent}
              />
            );
          case "Google Drive":
            return (
              <AutomateCreateIn
                type={type}
                configuration={googleDriveConfiguration}
                setConfiguration={setGoogleDriveConfiguration}
                setShowCategory={handlePopUps}
                formAutomateContainerRef={formAutomateContainerRef}
                iconType={<DriveIcon height={"25px"} width={"25px"} />}
                IconHeaderModAddConnection={DriveIcon}
                typeVariableModal={typeVariableModal}
                setTypeVariableModal={setTypeVariableModal}
                showVariableListModal={showVariableListModal}
                setShowVariableListModal={setShowVariableListModal}
                showVariableModal={showVariableModalIn}
                setShowVariableModal={setShowVariableModalIn}
                // setQuestion={setQuestion}
                selectedAgent={selectedAgent}
              />
            );
          case "Dropbox":
            return (
              <AutomateCreateIn
                type={type}
                configuration={dropBoxConfiguration}
                setConfiguration={setDropBoxConfiguration}
                setShowCategory={handlePopUps}
                formAutomateContainerRef={formAutomateContainerRef}
                iconType={<DropboxIcon height={"25px"} width={"25px"} />}
                IconHeaderModAddConnection={DropboxIcon}
                typeVariableModal={typeVariableModal}
                setTypeVariableModal={setTypeVariableModal}
                showVariableListModal={showVariableListModal}
                setShowVariableListModal={setShowVariableListModal}
                showVariableModal={showVariableModalIn}
                setShowVariableModal={setShowVariableModalIn}
                // setQuestion={setQuestion}
                selectedAgent={selectedAgent}
              />
            );
          case "WhatsApp":
            return (
              <AutomateCreateIn
                type={type}
                configuration={whatsAppConfiguration}
                setConfiguration={setWhatsAppConfiguration}
                setShowCategory={handlePopUps}
                formAutomateContainerRef={formAutomateContainerRef}
                iconType={<WhatsAppIcon height={"28px"} width={"28px"} />}
                IconHeaderModAddConnection={WhatsAppIcon}
                typeVariableModal={typeVariableModal}
                setTypeVariableModal={setTypeVariableModal}
                showVariableListModal={showVariableListModal}
                setShowVariableListModal={setShowVariableListModal}
                showVariableModal={showVariableModalIn}
                setShowVariableModal={setShowVariableModalIn}
                // setQuestion={setQuestion}
                selectedAgent={selectedAgent}
              />
            );
          case "One Drive":
            return (
              <AutomateCreateIn
                type={type}
                configuration={oneDriveConfiguration}
                setConfiguration={setOneDriveConfiguration}
                setShowCategory={handlePopUps}
                formAutomateContainerRef={formAutomateContainerRef}
                iconType={<OneDriveIcon height={"25px"} width={"25px"} />}
                IconHeaderModAddConnection={OneDriveIcon}
                typeVariableModal={typeVariableModal}
                setTypeVariableModal={setTypeVariableModal}
                showVariableListModal={showVariableListModal}
                setShowVariableListModal={setShowVariableListModal}
                showVariableModal={showVariableModalIn}
                setShowVariableModal={setShowVariableModalIn}
                // setQuestion={setQuestion}
                selectedAgent={selectedAgent}
              />
            );
          case "Sharepoint":
            return (
              <AutomateCreateIn
                type={type}
                configuration={sharepointConfiguration}
                setConfiguration={setSharepointConfiguration}
                setShowCategory={handlePopUps}
                formAutomateContainerRef={formAutomateContainerRef}
                iconType={<SharepointIcon height={"25px"} width={"25px"} />}
                IconHeaderModAddConnection={SharepointIcon}
                typeVariableModal={typeVariableModal}
                setTypeVariableModal={setTypeVariableModal}
                showVariableListModal={showVariableListModal}
                setShowVariableListModal={setShowVariableListModal}
                showVariableModal={showVariableModalIn}
                setShowVariableModal={setShowVariableModalIn}
                // setQuestion={setQuestion}
                selectedAgent={selectedAgent}
              />
            );
          default:
            return <></>;
        }
      })()} */}
       <VariableModal
                setShowVariableModal={setShowCategory}
                VariableModal={showCategory}
                type={"category"}
                configuration={configuration}
                setConfiguration={setConfiguration}
              />
      {/* {(() => {
        switch (type) {
          case "Gmail":
            return (
              <VariableModal
                setShowVariableModal={setShowCategory}
                VariableModal={showCategory}
                type={"category"}
                configuration={gmailConfiguration}
                setConfiguration={setGmailConfiguration}
              />

            );
          case "Outlook":
            return (
              <VariableModal
                setShowVariableModal={setShowCategory}
                VariableModal={showCategory}
                type={"category"}
                configuration={outlookConfiguration}
                setConfiguration={setOutlookConfiguration}
              />
              
            );
          case "Google Drive":
            return (
              <VariableModal
                setShowVariableModal={setShowCategory}
                VariableModal={showCategory}
                type={"category"}
                configuration={googleDriveConfiguration}
                setConfiguration={setGoogleDriveConfiguration}
              />
              
            );
          case "Dropbox":
            return (
              <VariableModal
                setShowVariableModal={setShowCategory}
                VariableModal={showCategory}
                type={"category"}
                configuration={dropBoxConfiguration}
                setConfiguration={setDropBoxConfiguration}
              />
              
            );
          case "WhatsApp":
            return (
              <VariableModal
                setShowVariableModal={setShowCategory}
                VariableModal={showCategory}
                type={"category"}
                configuration={whatsAppConfiguration}
                setConfiguration={setWhatsAppConfiguration}
              />
              
            );
          case "One Drive":
            return (
              <VariableModal
                setShowVariableModal={setShowCategory}
                VariableModal={showCategory}
                type={"category"}
                configuration={oneDriveConfiguration}
                setConfiguration={setOneDriveConfiguration}
              />
              
            );
          case "Sharepoint":
            return (
              <VariableModal
                setShowVariableModal={setShowCategory}
                VariableModal={showCategory}
                type={"category"}
                configuration={sharepointConfiguration}
                setConfiguration={setSharepointConfiguration}
              />
              
            );
          default:
            return null;
        }
      })()} */}

      {showQrWhatsApp && (
        <AddConnectionModal
          close={() => handlePopUps("qr")}
          type="WhatsApp"
          icon={<WhatsAppIcon />}
          IconHeader={<WhatsAppIcon height={"30px"} width={"30px"} />}
          custonHeight="auto"
          customCss={"customCss"}
          // setQuestion={setQuestion}
          selectedAgent={selectedAgent}
        >
          {qr ? (
            <div className={styles.qrContainer}>
              <img src={qr} alt="whatsapp" />
            </div>
          ) : showFormtoGetQr ? (
            <form
              onSubmit={(e) => {
                e.stopPropagation();
                e.preventDefault();
                generateQR(e);
              }}
              className={styles.formContent}
              ref={formRef}
              onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Escape") {
                  setShowFormtoGetQr(false);
                  setShowQrWhatsApp(false);
                }
              }}
              tabIndex="0"
            >
              <div className={styles.contentInput}>
                <label htmlFor="deviceName">{t("deviceName")}</label>
                <div className={styles.inputContainer}>
                  <input
                    type="text"
                    id="deviceName"
                    value={deviceName}
                    onChange={(e) => setDeviceName(e.target.value)}
                    placeholder={t("MyPhoneWorkPhone")}
                    required
                    className={styles.inputNameDevice}
                  />
                </div>
              </div>
              <button
                type="submit"
                disabled={deviceName.length < 3}
                className={styles.buttonNameDevice}
              >
                {t("generateQrCode")}
              </button>
            </form>
          ) : (
            <div className={styles.qrContainer}>
              <span className={styles.loader}></span>
            </div>
          )}
        </AddConnectionModal>
      )}
    </>
  );
};

export default AutomatesComponentIn;
